import React, { Component } from 'react';
import { connect } from 'react-redux';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { search, clearSearchResults } from '../actions/searchActions';
import { flatten } from 'lodash';
import Searchbar from '../components/Searchbar';

class AppSearchbar extends Component {

  state = {
    query: '',
    selected: 0
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
      delete this.timer;
    }
  }

  handleKeyDown = (evt) => {
    switch (evt.which) {
      case 13:
        this.select(evt);
        break;
      case 38:
        this.moveUp(evt);
        break;
      case 40:
        this.moveDown(evt);
        break;
      default:
    }

  }

  moveDown = (evt) => {
    evt.preventDefault();
    const { selected } = this.state;
    if (selected < this.getCount() - 1) {
      this.setState({ selected: selected + 1 });
    }
  }

  moveUp = (evt) => {
    evt.preventDefault();
    const { selected } = this.state;
    if (selected > 0) {
      this.setState({ selected: selected - 1 });
    }
  }

  getCount = () => {
    const { results } = this.props;

    if (!results)
      return 0;

    const selRes = results || [];
    return Object.values(selRes).reduce((prev, v) => prev+v.hits.length, 0);
  }

  select = (evt) => {
    evt.preventDefault();
    const { selected } = this.state;
    const { results, query } = this.props;
    if (query !== ''  && results) {
      const flatRes = flatten(results.map(r => r.hits));
      const target = flatRes[selected];
      this.closeResults();
      this.props.onSelect(target);
    }
  }

  selectWithClick = (item) => () => {
    const { onSelect } = this.props;
    this.closeResults();
    onSelect(item);
  }

  closeResults = () => {
    const { dispatch } = this.props;
    this.handleChange({
      target: { value: '' }
    });
    dispatch(clearSearchResults());
  }

  handleChange = (evt) => {
    const val = evt.target.value;
    this.search(val);
    this.setState({ query: val, selected: 0 });
  }

  search = (query) => {
    const { dispatch } = this.props;

    if (query.length >= 3) {
      if (this.timer) {
        clearTimeout(this.timer);
        delete this.timer;
      }

      if (query.match(/^[A-Za-z ]+$/))
        // prefix matching
        query = `${query}*`

      this.timer = setTimeout(function() {
        dispatch(search(query));
      }, 500);
    }
  }

  render() {
    const { results } = this.props;
    const { query, selected } = this.state;
    return (
      <ClickAwayListener onClickAway={this.closeResults}>
        <div>
          <Searchbar
            query={query}
            results={results}
            selected={selected}
            onChange={this.handleChange}
            onKeyDown={this.handleKeyDown}
            onClose={this.closeResults}
            onSelect={this.selectWithClick}
          />
        </div>
      </ClickAwayListener>
    )
  }
}

const mapStateToProps = state => {
  const { mainSearchbar } = state;

  return {
    results: mainSearchbar.results
  }
};

export default connect(mapStateToProps)(AppSearchbar);
